import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Badge } from "./Badge";
import { ButtonBase } from "./ButtonBase";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const navigationRailIconClasses = {
    root: "MinervaNavigationRailIcon-root",
    label: "MinervaNavigationRailIcon-label",
    badge: "MinervaNavigationRailIcon-badge",
    selected: "MinervaNavigationRailIcon-selected",
    disabled: "MinervaNavigationRailIcon-disabled",
};
export const navigationRailIconSlots = {
    badge: Badge,
};
export const NavigationRailIcon = (props) => {
    const { badge, density = "comfortable", selected, color = "surface", colorSet, invertColors, slots, slotProps, sx, className, disabled, children, ...rest } = useDefaultProps({ component: "NavigationRailIcon", props });
    return (_jsx(SlotsProvider, { baseSlots: navigationRailIconSlots, slots: slots, children: ({ badge: Badge }) => (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: !invertColors, children: (colorStyles) => (_jsx(ButtonBase, { className: clsx([
                    navigationRailIconClasses.root,
                    selected && navigationRailIconClasses.selected,
                    disabled && navigationRailIconClasses.disabled,
                    className,
                ]), sx: mergeSx({
                    padding: density === "comfortable" ? 3 : density === "dense" ? 2 : 0,
                    color: colorStyles.color,
                    backgroundColor: "transparent",
                    borderRadius: (theme) => theme.radius.full,
                    [`&.${navigationRailIconClasses.selected}`]: {
                        ...colorStyles,
                    },
                    [`&.${navigationRailIconClasses.disabled}`]: {
                        color: (theme) => theme.palette.disabled.main,
                        backgroundColor: "transparent",
                    },
                }, sx), ...rest, children: children && (_jsx(Badge, { label: badge, color: "error", placement: {
                        horizontal: "right",
                        vertical: "top",
                    }, ...slotProps?.badge, className: clsx([
                        navigationRailIconClasses.badge,
                        slotProps?.badge?.className,
                    ]), children: children })) })) })) }));
};
//# sourceMappingURL=NavigationRailIcon.js.map